import { render, staticRenderFns } from "./XTelInput.vue?vue&type=template&id=01be2844&scoped=true&"
import script from "./XTelInput.vue?vue&type=script&lang=js&"
export * from "./XTelInput.vue?vue&type=script&lang=js&"
import style0 from "./XTelInput.vue?vue&type=style&index=0&id=01be2844&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01be2844",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/anatec/wesave/wesave-conseil-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('01be2844', component.options)
    } else {
      api.reload('01be2844', component.options)
    }
    module.hot.accept("./XTelInput.vue?vue&type=template&id=01be2844&scoped=true&", function () {
      api.rerender('01be2844', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/controls/XTelInput.vue"
export default component.exports